import React, { useEffect, useState, useRef } from "react";
import { render } from "react-dom";
import {
  CircularProgressbar,
  buildStyles
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { easeQuadInOut } from "d3-ease";
import AnimatedProgressProvider from "../ui/AnimatedProgressProvider";
// import { DotLottieReact } from '@lottiefiles/dotlottie-react';
// import Lottie from 'lottie-react';
// import loader from '../../assets/animation/loader.lottie';
// import loader from '../../assets/animation/santa.mp4';
// import loader from '../../assets/animation/spin.json';
// import loadereee from '../../assets/animation/spinn.svg';
// import loader from '../../assets/animation/loader.png';
// import loader_two from '../../assets/animation/loader_two.png';
// import loader_two from '../../assets/animation/loader_two.png';
import MySnow from '../../components/ui/snow';
// import santa from '../../assets/animation/upd_santa.gif';

export default function PageLoader({ progress, isLoading }) {
  const [computedPercentage, setComputedPercentage] = useState(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    if (progress) {
      setComputedPercentage(progress.time);
    }
  }, [progress]);

  useEffect(() => {
    if (!isLoading && computedPercentage === 100) {
      setVisible(false);
    }
  }, [isLoading, computedPercentage]);

  if (!visible) return null;
  return (
    <div>
      <div className="overlay">
      {/* <div className="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div> */}
        {/* <MySnow snowflakeCount={200} radius={[5.0, 16.0]}/> */}
      {/* <DotLottieReact
        src={loader}
        loop
        autoplay
        /> */}
      
        <div className='loader-container'>
          <AnimatedProgressProvider
            valueStart={0}
            valueEnd={computedPercentage}
            duration={1.4}
            easingFunction={easeQuadInOut}
          >
            {value => (
              <>
                <CircularProgressbar
                  value={value}
                  // text={`${Math.round(value)}%`}
                  text={``}
                  strokeWidth={3}
                  styles={buildStyles({ pathTransition: "none" })}
                />
                {/* <div className="christmas-tree"><span></span></div> */}
              </>
            )}
          </AnimatedProgressProvider>
          <p className="loader-step">{progress?.step || "Fetching data from DB..."}</p>
        </div>
    {/* <Lottie animationData={loader} loop autoplay /> */}
      {/* {loadereee} */}
      {/* <img src={loader_two} alt="Loading animation" /> */}
      {/* <img src={loader_two} alt="Loading animation" /> */}
      {/* <div className="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div> */}
      </div>
    </div>
  )
}